import { Fragment, useEffect, useState } from 'react';
import ModalDialog from '../../../components/modalDialog/ModalDialog';
import ModalDialogContent from '../../../components/modalDialog/modalDialogContent/ModalDialogContent';
import ModalDialogButtons from '../../../components/modalDialog/modalDialogButtons/ModalDialogButtons';
import ImagePreviewModal from '../../../components/imagePreviewModal/ImagePreviewModal';

const CampaignSEOSprintSelectImageDialog = ({
	imagesData,
	onImageSelect,
	onClose,
	selectMultiple = false,
	arg = null
}) => {
	const [ isSelecting, setIsSelecting ] = useState(false);
	const [ showImagePreviewDialog, setShowImagePreviewDialog ] = useState(false);
	const [ imagePreviewSrc, setImagePreviewSrc ] = useState();
	const [ selectedImages, setSelectedImages ] = useState([]);

	const handleSelectedImageChange = (e, imageUrl) => {
		const { checked } = e.target;
		let tempSelectedImages = [ ...selectedImages ];

		if (checked) {
			if (tempSelectedImages && !tempSelectedImages.includes(imageUrl)) {
				tempSelectedImages.push(imageUrl);
			}
		} else {
			tempSelectedImages = tempSelectedImages.filter((x) => x !== imageUrl);
		}

		setSelectedImages(tempSelectedImages);
	};

	const handleSelectImage = () => {
		if (onImageSelect) {
			onImageSelect(arg, selectedImages);
		}
	};

	const handleCloseDialog = (e) => {
		if (onClose) {
			onClose(e);
		}
	};

	const toggleImagePreviewDialog = async (e, imageSrc) => {
		setShowImagePreviewDialog(!showImagePreviewDialog);

		if (!showImagePreviewDialog) {
			setImagePreviewSrc(imageSrc);
		} else {
			setImagePreviewSrc();
		}

		if (e) e.preventDefault();
	};

	return (
		<Fragment>
			<ModalDialog position="right-sidebar">
				<ModalDialogContent align="start">
					<div className="col-12">
						<div>
							<h6 className="mb-2">Select Images:</h6>
							<div className="locations-wrapper vh-100">
								{imagesData &&
								imagesData.images &&
								imagesData.images.length > 0 && (
									<Fragment>
										{imagesData.images.map((image, index) => {
											let isDisabled =
												!selectMultiple &&
												selectedImages &&
												selectedImages.length > 0 &&
												selectedImages[0] !== image.url;

											return (
												<div className="image-wrapper" key={index}>
													<img
														id={`img_${image.id}`}
														src={image.url}
														onClick={(e) => toggleImagePreviewDialog(e, image.url)}
														title="Preview Image"
													/>
													<input
														type="checkbox"
														className="form-check-input"
														id={`chkImg_${image.id}`}
														name={`chkImg_${image.id}`}
														//checked={imgIsSelected}
														onChange={(e) => handleSelectedImageChange(e, image.url)}
														disabled={isDisabled}
													/>
												</div>
											);
										})}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</ModalDialogContent>
				<ModalDialogButtons>
					<Fragment>
						<button className="btn btn-primary" onClick={handleSelectImage}>
							{isSelecting ? (
								<Fragment>
									<span className="spinner-border m-0 me-2" />
									<span>Selecting...</span>
								</Fragment>
							) : (
								<span>Select</span>
							)}
						</button>
						<button className="btn btn-outline-primary ms-2" onClick={handleCloseDialog}>
							Close
						</button>
					</Fragment>
				</ModalDialogButtons>
			</ModalDialog>

			{showImagePreviewDialog && (
				<ImagePreviewModal imageSrc={imagePreviewSrc} onClose={(e) => toggleImagePreviewDialog(e)} />
			)}
		</Fragment>
	);
};

export default CampaignSEOSprintSelectImageDialog;
